// extracted by mini-css-extract-plugin
export default {"customPaddingTop":"style-module--customPaddingTop--pgJj5","asideBoxShadow":"style-module--asideBoxShadow--C4Vgv","negativeMargin":"style-module--negativeMargin--YGik7"};